import { Paper, Stack, Typography } from "@mui/material";
import SqlQueryItem from "@entrilia/shared/components/sqlTrace/SqlQueryItem";
import { convertISODateTimeWithSeconds } from "@entrilia/shared/utilities/dateUtils";
import type { CapturedBatch, QueryTraceItem } from "../../../api/smartViewsTraceTypes";

interface Props {
  batch: CapturedBatch;
  queries: QueryTraceItem[];
}

const TraceBatchCard = ({ batch, queries }: Props) => (
  <Paper variant="outlined" sx={{ p: 1.5 }}>
    <Typography variant="caption" component="div" color="textSecondary" sx={{ mb: 1 }}>
      {convertISODateTimeWithSeconds(batch.capturedAtUtc)} · {batch.reportUsage}
      {batch.requestPath ? ` · ${batch.requestPath}` : ""} · {queries.length}{" "}
      {queries.length === 1 ? "query" : "queries"}
    </Typography>
    <Stack spacing={1}>
      {queries.map((query, queryIndex) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <SqlQueryItem key={`${batch.id}-${queryIndex}`} item={query} />
      ))}
    </Stack>
  </Paper>
);

export default TraceBatchCard;
